/*
 * @Author: zhuqiu
 * @Date: 2020-05-19 13:53:54
 * @LastEditTime: 2020-06-02 13:47:07
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\Owner\schema.ts
 */
import { DataType } from "../../../../form/typings";
import { styleControlOptions } from "../../../../form/component-schema";
import i18n from "../../../i18n";
export default {
    $id: "ownerId",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        mappings: {
            type: DataType.String,
            title: i18n.t('dataitem.Mapping').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
